
import { Component, Vue } from "vue-property-decorator";
import { TCategory, TStep } from "@/models/questionnaire";
import { API_ROUTES } from "@/utils/API";

@Component({
  components: {
    ProfileRow: () => import("@/components/DetailsSummaryPage/components/ProfileRow.vue"),
  },
})
export default class DetailsSummaryPage extends Vue {
  complianceProfile: TCategory[] = [];

  mounted() {
    this.getComplianceProfile();
  }

  async getComplianceProfile() {
    const { data } = await this.axios.get<TCategory[]>(API_ROUTES.COMPLIANCE_PROFILE, {
      params: { alias: this.$route.meta.alias },
    });

    this.complianceProfile = data;
  }

  getStepAnswerBlocks(step: TStep) {
    return step?.question?.answer_blocks ?? [];
  }

  getStepLabel(step: TStep) {
    return step?.question?.show_label && step?.question?.label;
  }
}
